import { render, staticRenderFns } from "./wcrd_fee_sch.vue?vue&type=template&id=1729bd40&scoped=true&"
import script from "./wcrd_fee_sch.vue?vue&type=script&lang=js&"
export * from "./wcrd_fee_sch.vue?vue&type=script&lang=js&"
import style0 from "./wcrd_fee_sch.vue?vue&type=style&index=0&id=1729bd40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1729bd40",
  null
  
)

export default component.exports